import { render, staticRenderFns } from "./WeatherForecast.vue?vue&type=template&id=638c5c10&"
import script from "./WeatherForecast.vue?vue&type=script&lang=js&"
export * from "./WeatherForecast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports